/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import BossDialog from "../../components/BossDialog";
import { Form, FormElement } from "@progress/kendo-react-form";
import * as API from "../../framework/API/api"
import { BUCKET_CONFIG_TYPE, ENTITYNAME, LOGEVENT, MODULE } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";


export const BucketsConfigurationsEditForm = (props) => {

  const lang = useTranslation();
  const blankDataItem = {
    ...props.item,
    SID: props.item.SID ?? 0,
    Name: props.item.copy ? 'copy of ' + props.item.Name : props.item.Name ?? '',
    AccessKeyId: props.item.AccessKeyId ?? '',
    SecretAccessKey: props.item.SecretAccessKey ?? '',
    Region: props.item.Region ?? '',
    Type: { _id: props.item.Type, Description: utility.getKeyByValue(BUCKET_CONFIG_TYPE, props.item.Type) },
    Archive: props.item.Archive ?? false,
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  useEffect(() => {
  }, [])



  //function to check the validation in form
  function validationCheck() {

    if (dataItem.Name == undefined || dataItem.Name.trim().length == 0 || dataItem.Name == "") {
      toast.error(`${lang.please_enter_name_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (dataItem.AccessKeyId == undefined || dataItem.AccessKeyId.trim().length == 0 || dataItem.AccessKeyId == "") {
      toast.error(`${lang.please_enter_access_key_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (dataItem.SecretAccessKey == undefined || dataItem.SecretAccessKey.trim().length == 0 || dataItem.SecretAccessKey == "") {
      toast.error(`${lang.please_enter_secret_key_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }    
    return true;
  }

  const handleSubmit = async (e) => {

    if (validationCheck()) {
      const saveData = {
        _id: dataItem._id,
        SID: dataItem.SID ?? 0,
        Name: dataItem.Name,
        AccessKeyId: dataItem.AccessKeyId,
        SecretAccessKey: dataItem.SecretAccessKey,
        Region: dataItem.Region,
        Type: dataItem.Type._id,
        Archive: dataItem.Archive ?? false,
      }
      console.log(saveData);

      let res = await API.saveData(ENTITYNAME.BUCKET_CONFIGURATIONS, saveData);
      if (res.success) {
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.BUCKET_CONFIGURATIONS, data: res.data, message: res.message };
        API.SaveLogs(logData);
        utility.deleteLocalStorageItem(ENTITYNAME.BUCKET_CONFIGURATIONS);
        props.cancelEdit();
        props.refresh();
      }      
      else {
        toast.error(res.message, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    }
  }

  const onChangeForm = (e) => {

    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

  }

  return (
    <BossDialog
      title={props.item.SID > 0 ? props.item.Name : "Create Bucket Configuration"}
      onClose={props.cancelEdit}
      width={"770px"}
    >
      <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
      <Form
        initialValues={dataItem}
        render={(formRenderProps) => (
          <FormElement>
            <div className="row mt-2">
              <div className="col-12">
                <div className="row">
                  <div className="col-6">
                    <label>{lang.name_label} *</label>
                    <input
                      name={"Name"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Name}
                    />
                  </div>
                  <div className="col-6">
                    <label>{lang.access_key_label} *</label>
                    <input
                      name={"AccessKeyId"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.AccessKeyId}
                    />
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-6">
                    <label>{lang.secret_access_key_label} *</label>
                    <input
                      name={"SecretAccessKey"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.SecretAccessKey}
                    />
                  </div>
                  <div className="col-6" >
                    <label>{lang.region_label}</label>
                    <input
                      name="Region"
                      className="form-control form-control-sm"
                      value={dataItem.Region}
                      type="text"
                      onChange={onChangeForm}
                      min={0}
                    />
                  </div>
                </div>
                <div className="row mt-2">                  
                  <div className="form-group col-6">
                    <label htmlFor="TabView">{lang.type_label}</label>                      
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={
                          Object.keys(BUCKET_CONFIG_TYPE).map((obj) => {
                              return {
                                  _id: BUCKET_CONFIG_TYPE[obj],
                                  Description: obj
                              }
                          })
                      }
                      name="Type"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.Type}
                      onChange={onChangeForm}
                  />
                  </div>
                  <div className="col-6 mt-4" >
                    <input type={"checkbox"} name={"Archive"}
                      onChange={(e) => onChangeForm(e)}
                      value={dataItem.Archive}
                      checked={dataItem.Archive} />
                    <label className="ml-1">{lang.archive}</label>
                  </div>
                </div>
                
              </div>
            </div>
          </FormElement>
        )}
      />
      
    </BossDialog>)
};